/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TableComponent from '../../components/TableComponent';
import PassportModal from '../../Modals/passportModal';

const RejectedStoresList = () => {
  const navigate = useNavigate();

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const rows = [
    {
      id: 1,

      address: '1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ',
    },
    {
      id: 2,
      address: '1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ',
    },
    {
      id: 3,
      address: '1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ',
    },
    {
      id: 4,
      address: '1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ',
    },
    {
      id: 5,
      address: '1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ',
    },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Owner Details',
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate('/profile-detail/store')}>
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> +9203024595467 <br />
              emma@gmail.com
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: 'storeName',
      headerName: 'Store Details',
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure>
              <img src="/static/images/car_image.jpeg" alt="" />
            </figure>
            <p>
              <b>Car Masters</b>
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 300,
      field: 'address',
      headerName: 'Address',
      editable: false,
      sortable: false,
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={handleClose1}>Delete</MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const hidden = ['fullName'];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>

      <PassportModal open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default RejectedStoresList;
